import { toApiError } from "@/shared/api/errors";

/**
 * 从没选过城的家（DEPART-CITY-GUIDE-117，I 10-16；A HOME-PLACE-PENDING-117 的口径）：/home/place 给 chosen=false，城市、片区、时区都是空的，
 * 世界不为 TA 推进、出发站没有选项，出门回 409、原因 home_place_unchosen。这里只认这一种出错：http 409 且原因是 home_place_unchosen；
 * 别的 409、500、断网都不算（出发站照旧那一套）。单放一个文件：组件文件只导出组件，开发时热更新不受影响。
 */
export function homePlaceUnchosen(error: unknown): boolean {
  const problem = toApiError(error);
  return problem.kind === "http" && problem.status === 409 && problem.details?.reason === "home_place_unchosen";
}
